import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import GamesMarquee from "@/components/GamesMarquee";
import Steps from "@/components/Steps";
import WooferBlock from "@/components/WooferBlock";
import Pricing from "@/components/Pricing";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import OrderDialog from "@/components/OrderDialog";

const Home = () => {
  const [orderPlan, setOrderPlan] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSelectPlan = (plan) => {
    setOrderPlan(plan);
    setDialogOpen(true);
  };

  return (
    <div className="bg-[#0c0d12] text-[#f0f2f5] antialiased min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <GamesMarquee />
        <Steps />
        <WooferBlock />
        <Pricing onSelectPlan={handleSelectPlan} />
        <Reviews />
        <Faq />
      </main>
      <Footer />
      <OrderDialog plan={orderPlan} open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
};

export default Home;
